import Home from "./components/Promotion/Home";
// import PlayParticipate from "./components/Promotion/play_Participate";
import PlayParticipated from "./components/Promotion/play_Participated";
import PlayCelebrate from "./components/Promotion/play_Celebrate";
import RegisterParticipation from "./components/Promotion/register_participation";
import PlayThankYou from './components/Promotion/play_ThankYou';
import Error from './components/Promotion/play_Error';
import WinningMomentPage from './components/Promotion/play_wwmm';
import PolicyCookies from './components/Promotion/play_PolicyCookies';
import PromoEnded from './components/Promotion/play_promo_ended';
import Form from './components/Promotion/play_form';
import FormOk from './components/Promotion/play_form_ok';
import Signed from './components/Promotion/play_signed';
const AppRoutes = [
  {
    index: true,
    element: <PromoEnded />
  },
 /* {
    path: `/${process.env.REACT_APP_HOME}`,
    element: <PromoEnded />
  },
  // {
  //   path: `/${process.env.REACT_APP_HOME}`,
  //   element: <PlayParticipate />
  // },
   {
    path: `/${process.env.REACT_APP_HOME}/sign`,
    element: <Form />
  },
    {
    path: `/${process.env.REACT_APP_HOME}/recibido`,
    element: <FormOk />
  },
  {
    path: `/${process.env.REACT_APP_HOME}/policycookies`,
    element: <PolicyCookies />
  },
  {
    path: `/${process.env.REACT_APP_HOME}/winningmoment`,
    element: <WinningMomentPage />
  },
  {
    path: `/${process.env.REACT_APP_HOME}/hasparticipado`,
    element: <PlayParticipated />
  },
  {
    path: `/${process.env.REACT_APP_HOME}/hasganado`,
    element: <PlayCelebrate />
  },
  {
    path: `/${process.env.REACT_APP_HOME}/gracias`,
    element: <PlayThankYou />
  },
   {
    path: `/${process.env.REACT_APP_HOME}/signed`,
    element: <Signed />
  },
   {
    path: `/api/aceptacion-concluida`,
    element: <Signed />
  },*/
  {
    path: `/${process.env.REACT_APP_HOME}/error`,
    element: <Error />
  },
  {
    path: '*',
    element: <PromoEnded />
  }
];

export default AppRoutes;